export class ResizeOptions {
    public Resize_Max_Height = 800;
    public Resize_Max_Width = 1000;
    public Resize_Quality = 70;
    public Resize_Type = 'image/jpg';
}
